module.exports = __webpack_public_path__ + "static/media/Pain Management-Treatment History-1@3x.4a863ee5.png";